/**
 * External Dependencies
 */
import 'jquery';

// import 'bootstrap/js/src/modal';

// Slick Slider
import 'slick-carousel/slick/slick.min';

// Import Mask
import 'jquery-mask-plugin/dist/jquery.mask.min';

// JS Applied to all the pages
import './images-lightbox.js';
import './gallery-lightbox.js';
import './common.js';

$(() => {
    // console.log('Hello world');
});